import * as React from "react";
import classNames from "classnames";
import styles from "./Icon.module.css";

interface IconProps {
  name: string;
  className?: string;
  size?: "small" | "medium" | "large";
}

const Icon: React.FC<IconProps> = ({
  name,
  size = "medium",
  className = "",
}) => (
  <span className={classNames(styles.wrapper, className)}>
    <svg
      aria-hidden="true"
      focusable="false"
      className={classNames(styles.svg, styles[size])}
    >
      <use href={`#${name}`} />
    </svg>
  </span>
);

export default Icon;
